import frecce from "../images/frecce.png";

function UserForm({
  comprensorio,
  email,
  username,
  password,
  onEmailChange,
  onUsernameChange,
  onPasswordChange,
  onSubmit,
}) {
  return (
    <div className={`d-flex align-items-center justify-content-center`}>
      <main className="form-signin w-100 m-auto" style={{ maxWidth: "330px" }}>
        <form onSubmit={onSubmit}>
          <img
            className="w-100"
            src={frecce}
            alt=""
            width="50"
            height="150"
          />

          <h1 className="h3 mb-3 fw-normal text-center">
            Registrazione utente ({comprensorio.nome})
          </h1>

          <div className="form-floating">
            <input
              type="email"
              className="form-control"
              id="floatingEmail"
              placeholder="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              required
            />
            <label htmlFor="floatingEmail">Email</label>
          </div>

          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="floatingUsername"
              placeholder="username"
              value={username}
              onChange={(e) => onUsernameChange(e.target.value)}
              required
            />
            <label htmlFor="floatingUsername">Username</label>
          </div>

          <div className="form-floating">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Password"
              value={password}
              onChange={(e) => onPasswordChange(e.target.value)}
              required
            />
            <label htmlFor="floatingPassword">Password</label>
          </div>

          <button className="btn btn-primary w-100 py-2" type="submit">
            Iscriviti
          </button>
        </form>
      </main>
    </div>
  );
}

export default UserForm;
